export default defineNuxtRouteMiddleware(async to => {
  const auth = useAuth()
  const toast = useToast()

  // Check if this is an invite route and user is already logged in
  if (to.path.startsWith('/invite/') && auth.loggedIn) {
    // User is already authenticated, redirect to dashboard
    // This prevents authorization middleware conflicts when accessing invites for different leads

    // Show toast after navigation completes
    setTimeout(() => {
      toast.add({
        severity: 'error',
        summary: "You're currently signed in.",
        detail: 'Log out to accept a new invitation using a different account.',
        life: 10000,
        closable: true,
      })
    }, 100)

    return navigateTo('/')
  }
})
